import "@bvm/bosp-style/dist/style.css";

import "./assets/js/accordion";
import "./assets/js/anchor";
import "./assets/js/browser-compatibility";
import "./assets/js/contextual-buttons";
import "./assets/js/date-helper-function";
import "./assets/js/dropdown";
import "./assets/js/event-bus";
import "./assets/js/fileUpload";
import "./assets/js/footerlist";
import "./assets/js/menu";
import "./assets/js/modal";
import "./assets/js/overlay";
import "./assets/js/overlay-functions";
import "./assets/js/stickyfooter";
import "./assets/js/tabs";
import "./assets/js/url";
import "./assets/js/vehicle-details-header";

import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-getcanonicallocales/polyfill';
import '@formatjs/intl-numberformat/dist/locale-data/en';
import '@formatjs/intl-numberformat/dist/locale-data/nl';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/nl';

import Vue from 'vue';
import VueI18n from "vue-i18n";
import vueDebounce from "vue-debounce";
import Vuelidate from 'vuelidate';
import router from './router';

import ComponentLibrary from "./auto-register-components";
import {initI18n} from "@bvm/core";
import {loadI18n} from "./load-i18n";

export default ComponentLibrary;

export const init = function(options) {
    Vue.use(VueI18n);
    Vue.use(vueDebounce);
    Vue.use(Vuelidate);
    Vue.config.devtools = true;

    const vue = new Vue({
        i18n: initI18n(),
        router,
        ...options
    });

    loadI18n(vue);
    return vue;
}

window.Bovemij = window.Bovemij || {};
window.Bovemij.EmployeeAdmin = window.Bovemij.EmployeeAdmin || {};
window.Bovemij.EmployeeAdmin.initVue = init;